import React from 'react';

import { formatPeopleCount } from '../../../../../../../utils/helpers';
import { TooltipContainer, Value, ValueText } from './GraphTooltip.styles';

interface GraphTooltipProps {
  dataKey: string;
  count: number;
}
const GraphTooltip = ({ dataKey, count }: GraphTooltipProps) => {
  return (
    <TooltipContainer>
      <Value>{formatPeopleCount(count)}</Value>
      <ValueText>{dataKey}</ValueText>
    </TooltipContainer>
  );
};

export default GraphTooltip;
